<template>
  <div class="mt-6">
    <h4 class="mb-2">Налоговый - Получить данные</h4>
    <v-card>
      <v-card-text>
        <validation-observer ref="formObserver" v-slot="{handleSubmit}">
          <form @submit.prevent="handleSubmit(submit)">
            <v-row dense>
              <v-col md="3" sm="6" cols="12">
                <custom-select
                    :items="typesData"
                    rules="required"
                    v-model="taxData.type"
                    vid="type"
                    label="Выберите тип данных"
                ></custom-select>
              </v-col>
              <v-col md="3" sm="6" cols="12">
                <custom-input-text
                    class="flex-grow"
                    :pattern="'#########'"
                    label="ИНН"
                    :rules="{
                    required: !hasPNFLInput || !taxData.pnfl,
                    inn: true
                  }"
                    vid="tin"
                    v-model="taxData.tin"
                ></custom-input-text>
              </v-col>
              <v-col md="3" sm="6" class="d-flex" cols="12" v-if="hasPNFLInput">
                <p class="mt-2 mr-2">ИЛИ</p>
                <custom-input-text
                    class="flex-grow-1"
                    :pattern="'##############'"
                    label="ПИНФЛ"
                    rules="pnfl"
                    vid="pnfl"
                    v-model="taxData.pnfl"
                ></custom-input-text>
              </v-col>
              <v-col md="3" sm="6" cols="12">
                <v-btn :disabled="!canSubmit" :width="$vuetify.breakpoint.xs ? '100%' : null" type="submit"
                       color="primary">Получить данные {{ mko.price_tax ? '(' + mko.price_tax + ' сум)' : '' }}
                </v-btn>
              </v-col>
            </v-row>
          </form>
        </validation-observer>
      </v-card-text>
    </v-card>
    <v-dialog :max-width="selectedType && selectedType.maxWidthDialog ? selectedType.maxWidthDialog : 500"
              v-model="infoDialog">
      <keep-alive v-if="!isTaxResponseFailed">
        <component @close="infoDialog = false" v-if="selectedType" :userData="userData"
                   :is="selectedType.component"></component>
      </keep-alive>
      <v-card v-else>
        <v-btn @click="infoDialog = false" absolute right class="mt-3" icon>
          <v-icon>fas fa-times</v-icon>
        </v-btn>
        <v-card-text>
          <v-card-title class="px-0"><h4>{{ selectedType.name }}</h4></v-card-title>
          <h3 class="error--text">{{ userData }}</h3>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import InfoTaxSalary from "@/components/calculation/calculator-tax/InfoTaxSalary"
import InfoTaxDebt from "@/components/calculation/calculator-tax/InfoTaxDebt";
import InfoTaxLoad from "@/components/calculation/calculator-tax/InfoTaxLoad";
import InfoTax from "@/components/calculation/calculator-tax/InfoTax";
import InfoProperty from "@/components/calculation/calculator-tax/InfoProperty";
import {mapGetters} from "vuex";
// import fakeTax from "@/components/calculation/calculator-tax/fakeTax";

export default {
  name: 'CalculatorTax',
  components: {InfoTaxSalary, InfoTaxDebt, InfoTaxLoad, InfoTax, InfoProperty},
  data() {
    return {
      infoDialog: false,
      typesData: [
        {
          name: 'Сведение о заработной плате',
          id: 'TAX_SALARY',
          component: 'InfoTaxSalary',
          maxWidthDialog: '90%'
        },
        {
          name: 'Налоговая задолженность',
          id: 'TAX_DEBT',
          component: 'InfoTaxDebt'
        },
        {
          name: 'Информация по физическим лицам',
          id: 'TAX_INFO',
          component: 'InfoTax'
        },
        {
          name: 'Сведение об имуществе физического лица',
          id: 'TAX_PROPERTY',
          component: 'InfoProperty'
        },
        {
          name: 'Сведение о сданной в аренду имущества физического лица',
          id: 'TAX_LOAD',
          component: 'InfoTaxLoad'
        },
      ],
      taxData: {
        type: null,
        tin: null
      },
      userData: null
    }
  },
  methods: {
    async submit() {
      try {
        this.$showLoading()
        let taxData = {...this.taxData}
        if (!taxData.tin) {
          delete taxData.tin
        }
        if (!taxData.pnfl) {
          delete taxData.pnfl
        }
        const {data: {data}} = await this.$http.post('admin/calculate/tax-info', taxData)
        this.userData = data
        // this.userData = fakeTax[this.taxData.type]
        this.infoDialog = true
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs.formObserver})
      } finally {
        this.$clearLoading()
      }
    }
  },

  computed: {
    ...mapGetters(['mko']),
    selectedType() {
      if (this.taxData.type) {
        const selectedTaxType = this.typesData.find(item => item.id === this.taxData.type)
        if (selectedTaxType) return selectedTaxType
      }
      return null
    },
    hasPNFLInput() {
      const {type} = this.taxData
      return type === 'TAX_SALARY' || type === 'TAX_INFO'
    },
    isTaxResponseFailed() {
      return this.userData !== null && typeof this.userData === 'string'
    },
    canSubmit() {
      return this.selectedType && this.mko.can_tax_array && this.mko.can_tax_array.includes(this.selectedType.id)
    }
  },
  watch: {
    infoDialog(val) {
      if (!val) {
        this.taxData = {
          type: null,
          tin: null
        }
        this.$refs.formObserver.reset()
        setTimeout(() => {
          this.userData = null
        }, 150)
      }
    }
  },
  async mounted() {
  }
}
</script>
